"use client"

import { motion } from 'framer-motion'
import { Button } from '@/components/ui/button'
import { CalendarPlus } from 'lucide-react'
import { trackEvent } from '@/lib/analytics'

type FreeConsultSectionProps = {
  title?: string
  subheading?: string
  description?: string | string[]
  duration?: string
}

export function FreeConsultSection({
  title = 'Free 15-Minute Phone Consult',
  subheading = 'Not Sure if This Is the Right Fit?',
  description = ['If you\'re unsure whether this style of care is right for you, you\'re welcome to book a free 15-minute phone consult.', 'This is a brief call to discuss your needs with Renee, ask questions and get a sense of whether Chinese Medicine and acupuncture might be helpful for you.'],
  duration = '15 minutes',
}: FreeConsultSectionProps) {
  const openBooking = (location: string) => {
    try {
      trackEvent('book_appointment_click', { location })
    } catch {}
    if (typeof window !== 'undefined' && (window as any).openBookingModal) {
      ;(window as any).openBookingModal(location)
    }
  }

  return (
    <section id="free-consult-section" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl mx-auto text-center"
        >
          <h2 className="text-2xl md:text-3xl mb-4 text-[#3f4141]">
            {title}
          </h2>
          <p className="text-lg text-gray-600 mb-6 max-w-2xl mx-auto">
            {subheading}
          </p>
          <div className="text-gray-600 mb-12 max-w-3xl px-4 md:px-0 mx-auto space-y-4">
            {Array.isArray(description) ? (
              description.map((para, index) => (
                <p key={index}>{para}</p>
              ))
            ) : (
              <p>{description}</p>
            )}
          </div>
          <div className="flex flex-col sm:flex-row gap-3 justify-center items-center sm:w-1/2 mx-auto">
            <Button 
              className="w-full sm:w-auto px-8 bg-[rgb(132,137,116)] hover:bg-gray-700 text-white" 
              onClick={() => openBooking('free_consult_section')}
              aria-label="Book Free Phone Consult"
            >
              <span className="inline-flex items-center gap-2">
                <CalendarPlus className="h-4 w-4" aria-hidden="true" />
                Book Free {duration} Consult
              </span>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  )
}

